import { useEffect, useState } from 'react';
import '../styles/theme.css';
import { fetchSettings } from '../lib/settings';

// Cache PWA install prompt across route changes (since layouts remount)
let cachedDeferredPrompt = null;
let cachedInstalled = false;

export default function Footer() {
  const year = new Date().getFullYear();
  const [settings, setSettings] = useState(null);
  const [deferredPrompt, setDeferredPrompt] = useState(cachedDeferredPrompt);
  const [installed, setInstalled] = useState(cachedInstalled);

  useEffect(() => {
    let mounted = true;
    fetchSettings()
      .then((s) => { if (mounted) setSettings(s); })
      .catch(() => { });
    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    const onBeforeInstall = (e) => {
      e.preventDefault();
      cachedDeferredPrompt = e;
      setDeferredPrompt(e);
    };
    const onInstalled = () => {
      cachedInstalled = true;
      setInstalled(true);
      cachedDeferredPrompt = null;
      setDeferredPrompt(null);
    };
    window.addEventListener('beforeinstallprompt', onBeforeInstall);
    window.addEventListener('appinstalled', onInstalled);
    if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
      cachedInstalled = true;
      setInstalled(true);
    }
    return () => {
      window.removeEventListener('beforeinstallprompt', onBeforeInstall);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      cachedDeferredPrompt = null;
      setDeferredPrompt(null);
    }
  };

  const resolve = (obj, keys = []) => {
    for (const k of keys) {
      const v = obj?.[k];
      if (typeof v === 'string' && v.trim()) return v.trim();
    }
    return '';
  };
  const ensureHttp = (url) => {
    if (!url) return '';
    return /^(https?:)?\/\//i.test(url) ? url : `https://${url}`;
  };

  return (
    <footer className="footer">
      <div className="container footer-inner">
        {settings && (
          <div style={{
            display: 'grid',
            gap: 10,
            justifyItems: 'center',
            padding: '0 0 12px 0'
          }}>
            <div className="footer-heading" style={{ color: '#111827', fontSize: '1.15rem', fontWeight: 600 }}>Suivez-nous sur nos réseaux</div>
            <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', justifyContent: 'center' }}>
              {(() => {
                const u = ensureHttp((settings?.socials?.facebook) || resolve(settings, ['facebook', 'facebook_url', 'fb', 'facebookLink', 'url_facebook', 'reseaux_facebook'])); return u ? (
                  <a href={u} target="_blank" rel="noreferrer" aria-label="Facebook" style={{ width: 44, height: 44, borderRadius: 999, border: '1px solid #e5e7eb', background: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none' }}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 12C22 6.477 17.523 2 12 2S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.988H7.898v-2.89h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.261c-1.243 0-1.63.772-1.63 1.562v1.875h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" fill="#374151" /></svg>
                  </a>
                ) : null;
              })()}
              {(() => {
                const u = ensureHttp((settings?.socials?.instagram) || resolve(settings, ['instagram', 'instagram_url', 'ig', 'instagramLink', 'url_instagram', 'reseaux_instagram'])); return u ? (
                  <a href={u} target="_blank" rel="noreferrer" aria-label="Instagram" style={{ width: 44, height: 44, borderRadius: 999, border: '1px solid #e5e7eb', background: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none' }}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm5 5a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm6.5-.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5z" stroke="#374151" strokeWidth="1.5" /><circle cx="12" cy="12" r="3.25" stroke="#374151" strokeWidth="1.5" /></svg>
                  </a>
                ) : null;
              })()}
              {(() => {
                const u = ensureHttp((settings?.socials?.linkedin) || resolve(settings, ['linkedin', 'linkedin_url', 'ln', 'linkedinLink', 'url_linkedin', 'reseaux_linkedin'])); return u ? (
                  <a href={u} target="_blank" rel="noreferrer" aria-label="LinkedIn" style={{ width: 44, height: 44, borderRadius: 999, border: '1px solid #e5e7eb', background: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none' }}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.94 7.5a1.94 1.94 0 1 1 0-3.88 1.94 1.94 0 0 1 0 3.88zM5 9h3.88v10.5H5V9zm6 0h3.72v1.44h.06c.52-.94 1.8-1.94 3.7-1.94 3.95 0 4.68 2.6 4.68 5.98V19.5H19.3v-4.7c0-1.12-.02-2.56-1.56-2.56-1.56 0-1.8 1.22-1.8 2.48v4.78H12V9z" fill="#374151" /></svg>
                  </a>
                ) : null;
              })()}
            </div>
            {(deferredPrompt && !installed) && (
              <div style={{ display: 'grid', justifyItems: 'center', padding: '10px 0 0 0', gap: 6, textAlign: 'center' }}>
                <button
                  onClick={handleInstallClick}
                  aria-label="Installer l'application"
                  style={{
                    padding: '10px 18px',
                    borderRadius: 10,
                    fontWeight: 600,
                    fontSize: '0.95rem',
                    background: '#f3f4f6',
                    color: '#111827',
                    border: '1px solid #e5e7eb',
                    cursor: 'pointer'
                  }}
                >
                  📲 Installer l'application
                </button>
                <div style={{ fontSize: 12, color: '#6b7280' }}>
                  Ajoutez l’app sur votre écran d’accueil pour une expérience plus rapide.
                </div>
              </div>
            )}
          </div>
        )}
        <div className="footer-top">
          <div className="footer-col footer-brand">
            <div className="footer-logo">AEF32</div>
            <p className="footer-text">
              Solutions de portails, automatismes et fermetures pour les particuliers et les professionnels en Occitanie.
            </p>
          </div>

          <div className="footer-col">
            <h3 className="footer-heading">Navigation</h3>
            <ul className="footer-links">
              <li><a href="/">Accueil</a></li>
              <li><a href="/catalogue">Catalogue</a></li>
              <li><a href="/realisations">Réalisations</a></li>
              <li><a href="/services">Services</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h3 className="footer-heading">Contact</h3>
            <ul className="footer-links">
              <li>AEF32</li>
              <li>{settings?.address || settings?.adresse || settings?.location || 'Occitanie, France'}</li>
              <li>
                <a
                  href={settings?.phone || settings?.telephone || settings?.tel
                    ? `tel:${String((settings.phone || settings.telephone || settings.tel)).replace(/\s+/g, '')}`
                    : 'tel:+33000000000'}
                >
                  {settings?.phone || settings?.telephone || settings?.tel || '+33 (0)0 00 00 00 00'}
                </a>
              </li>
              <li>
                <a href={`mailto:${settings?.email || 'contact@aef32.fr'}`}>
                  {settings?.email || 'contact@aef32.fr'}
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h3 className="footer-heading">Informations</h3>
            <ul className="footer-links">
              <li>N° de Siret : 909 916 884 00028</li>
              <li><a href="/mentions-legales">Mentions légales</a></li>
              <li><a href="/politique-de-confidentialite">Politique de confidentialité</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div> {year} AEF32. Tous droits réservés.</div>
        </div>
      </div>
    </footer>
  );
}
